import { setCookie } from 'rytm-helpers'
import { Modal } from 'bootstrap'


// Popup banner dismiss
const onPopupDismissClick = (e) => {
  e.preventDefault()
  const name = e.currentTarget.dataset.cname
  if (name) {
    setCookie(name, 1, 30)
  }
  const popup = e.currentTarget.closest("#popup_banner")
  if (popup) {
    $(popup).fadeOut()
  }
}

const onPopupAlertHide = (e) => {
  const cookieName = e.currentTarget.dataset.modalCookie;
  if (cookieName) {
    setCookie(cookieName, 1, .1);
  }
}

export const initPopup = () => {
  // Popup banner dismiss
  $('body').on('click', '.popup-dismiss', onPopupDismissClick)
  $('body').on('hide.bs.modal', '.modal[data-modal-cookie]', onPopupAlertHide)
  // open popupalert 
  const modalCookie = document.querySelector('.popupalert-full .modal');
  if (modalCookie) {
    const modal = new Modal(modalCookie);
    modal.show();
  }
}